module.exports = __webpack_public_path__ + "media/images/front/sns/instagram_logo-447bcb5a04a046fadc6630d8e7a1fd43.png";